module.exports = __webpack_public_path__ + "img/cover.539504f2.jpg";